export const DELETE_VENUE_LOG = 'DELETE_VENUE_LOG';
export const DELETE_VENUE_LOG_SUCCESS = 'DELETE_VENUE_LOG_SUCCESS';
export const DELETE_VENUE_LOG_ERROR = 'DELETE_VENUE_LOG_ERROR';

export const DeleteVenueLog = (data) => ({
  type: DELETE_VENUE_LOG,
  payload: data,
});
